import { skipToken, useQuery } from '@tanstack/react-query';

import useRutter from '~hooks/useRutter/useRutter';
import { Nullable } from '~types/Nullable';
import fetchAllRutterPages from '~utils/rutter/fetchAllRutterPages';

interface UseRutterLineItemMatchesQueryProps {
  connectionId: Nullable<string>;
  // polls while matching is still running on the backend
  refetchIntervalMs: number | false;
  settlementId: string;
}

export const rutterLineItemMatchesQueryKey = (
  connectionId: Nullable<string>,
  settlementId: string,
) => ['rutterLineItemMatches', connectionId, settlementId];

export default function useRutterLineItemMatchesQuery({
  connectionId,
  refetchIntervalMs,
  settlementId,
}: UseRutterLineItemMatchesQueryProps) {
  const { getLineItemMatches } = useRutter();

  return useQuery({
    queryKey: rutterLineItemMatchesQueryKey(connectionId, settlementId),
    refetchInterval: refetchIntervalMs,
    retry: false,
    queryFn: connectionId
      ? ({ signal }) =>
          fetchAllRutterPages(
            (pagination) =>
              getLineItemMatches(connectionId, settlementId, pagination, signal),
            { signal },
          )
      : skipToken,
  });
}
